import {
  ChartVisualizationData,
  LineValueData
} from "@repo/core/components/chart/ReportCharts/types";
import {
  TableDataRow,
  TableHeaderData
} from "@repo/core/components/core/DataTable/types";
import { ReportCardProps } from "@repo/core/screens/Reports/components/ReportCard/types";

export enum ReportTypeEnum {
  PROPOSALS = "proposals",
  SALES = "sales",
  MORE_INFO = "more_info",
  TICKETS = "average_ticket",
  PERCENTAGE = "percentage",
  QUANTITY = "quantity"
}

export type ReportType = {
  type: ReportTypeEnum;
  title: string;
};

export enum ReportCardEnum {
  ANALYSED_PROPOSALS = "analysed_proposals",
  REASON_DENIAL = "reason",
  MONTHLY_TRANSACTIONS = "monthly_transactions"
}

export type ReportsResponse = {
  reportName: string;
  filters: {
    endDate: Date;
    product: string;
    startDate: Date;
    store: string;
    type: ReportTypeEnum;
  };

  table: {
    headers: TableHeaderData[];
    rows: TableDataRow[];
  };
  charts?: {
    type: "bar" | "line";
    data: ChartVisualizationData[] | LineValueData;
  }[];
  mobileTable?: Omit<ReportCardProps, "variant">[];
};

export type GeneralReportTypes =
  | ReportTypeEnum.PROPOSALS
  | ReportTypeEnum.SALES
  | ReportTypeEnum.MORE_INFO;

export type ReasonDenialReportTypes =
  | ReportTypeEnum.PERCENTAGE
  | ReportTypeEnum.QUANTITY;

export type MonthlySalesReportTypes =
  | ReportTypeEnum.SALES
  | ReportTypeEnum.TICKETS;

export type SalesByStoreReportTypes =
  | ReportTypeEnum.PROPOSALS
  | ReportTypeEnum.SALES
  | ReportTypeEnum.MORE_INFO;
